import { useMembers } from '@ably/spaces/react';
import React from 'react';

import AvatarStack from '@/components/AvatarStack';

import { MemberProfile } from '../AvatarStack/types';

import { Props } from './types';

/**
 * NOTE: This component is business/domain-specific and does not belong in the
 * generic UI primitives library (ui/components). It should be moved to a more
 * appropriate domain-specific location in the codebase.
 */
const AvatarStackForSpace: React.FC<Props> = ({ maxAvatars = 5 }) => {
  const { members } = useMembers();

  const memberProfiles: MemberProfile[] = members.map((member) => {
    const profile = member.profileData as { avatar_url?: string; name?: string } | null;
    return {
      avatarUrl: profile?.avatar_url,
      name: profile?.name,
      connectionId: member.connectionId
    };
  });

  return <AvatarStack members={memberProfiles} maxAvatars={maxAvatars} />;
};

export default React.memo(AvatarStackForSpace);
